import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isDirty, getFormValues } from 'redux-form';
import { jsxActions as kitPdfDetailedLabelSettingsViewActions } from '../../../../actions/Administration/SettingsPage/kitPdfDetailedLabelSettingsViewActions';
import { jsxActions as settingsPageActions } from '../../../../actions/Administration/SettingsPage/settingsPageActions';
import KitPdfDetailedLabelSettingsView from '../../../../components/Administration/SettingsPage/PdfDetailedLabelSettings/KitPdfDetailedLabelSettingsView/kitPdfDetailedLabelSettingsView';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(kitPdfDetailedLabelSettingsViewActions, dispatch),
      settingsPageActions: bindActionCreators(settingsPageActions, dispatch)
    }
  }
}

let KitPdfDetailedLabelSettingsViewContainer = connect(
  (state) => {
    return {
      sData: state.administration.getIn(['settingsPage', 'kitPdfDetailedLabelSettingsView']),
      isHeaderDirty: isDirty('pdfDetailedLabelHeaderForm')(state),
      isRowDirty: isDirty('pdfDetailedLabelRowForm')(state),
      headerFormValues: getFormValues('pdfDetailedLabelHeaderForm')(state),
      rowFormValues: getFormValues('pdfDetailedLabelRowForm')(state),
    };
  },
  mapDispatchToProps
)(KitPdfDetailedLabelSettingsView);

export default KitPdfDetailedLabelSettingsViewContainer;
